import { useContext } from 'react';
import { FechamentoFiscalContext } from '../contexts/FechamentoFiscalContext';
import { FechamentoFiscalContextData } from '../types/context';

export const useFechamentoFiscal = (): FechamentoFiscalContextData =>
  useContext(FechamentoFiscalContext);
